// @ts-nocheck
/* eslint-disable */
import { createReducer } from 'reduxsauce';
import { Types } from '../actions/estimation_sheet_import';
const validExcelExtension = [
  'xla',
  'xlam',
  'xlr',
  'xls',
  'xlsx',
  'XLSX',
  'xlsm',
  'xlsb',
  'xlt',
  'xltx',
  'xltm',
  'xlw',
  'xml',
];

function getFileExtension(name) {
  if (!name) {
    return;
  }
  const lastDot = name.lastIndexOf('.');
  if (lastDot === -1) {
    return '';
  }
  const ext = name.substring(lastDot + 1);
  return ext;
}

const initialState = {
  isFullPage: false,
  step: 1,
  file: null,
  file2: null,
  fileErr: '',
  data: {},
  request: false,
  success: false,
  message: '',
  isParsing: false,
  parsingProgress: 0,
  globalDownloadData: null,
};

const setFullPageLayout = (state, action) => {
  const {
    payload: { isFullPage },
  } = action;
  return {
    ...state,
    isFullPage,
  };
};

const setStep = (state, action) => {
  const {
    payload: { step },
  } = action;
  return {
    ...state,
    step,
  };
};

const addFile = (state, action) => {
  const {
    payload: { file },
  } = action;

  const fileExt = getFileExtension(file.name);
  if (validExcelExtension.indexOf(fileExt) == -1) {
    return {
      ...state,
      fileErr: 'Please select a proper file.',
    };
  }

  return {
    ...state,
    file,
  };
};

const addFile2 = (state, action) => {
  const {
    payload: { file },
  } = action;

  const fileExt = getFileExtension(file.name);
  if (validExcelExtension.indexOf(fileExt) == -1) {
    return {
      ...state,
      fileErr: 'Please select a proper file.',
    };
  }

  return {
    ...state,
    file2: file,
  };
};

const removeFile = (state) => {
  return {
    ...state,
    file: null,
  };
};

const removeFile2 = (state) => {
  return {
    ...state,
    file2: null,
  };
};

const reset = () => initialState;

const saveEstimationDataRequest = (state, action) => {
  const { payload, data } = action;
  return {
    ...state,
    request: true,
    data,
  };
};

const saveEstimationDataSuccess = (state, action) => {
  return {
    ...state,
    request: false,
    success: true,
    responseFile: action.payload,
  };
};

const saveEstimationDataFailure = (state) => {
  return {
    ...state,
    request: false,
    success: false,
    // message: action.payload,
  };
};

const setParsingProgress = (state, action) => {
  const {
    payload: { progress },
  } = action;
  return {
    ...state,
    parsingProgress: progress,
  };
};

const setParsingState = (state, action) => {
  const {
    payload: { isParsing, parsingProgress },
  } = action;
  return {
    ...state,
    isParsing,
    parsingProgress,
  };
};

const setGlobalDownloadData = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    globalDownloadData: payload,
  };
};

const clearGlobalDownloadData = (state) => {
  return {
    ...state,
    globalDownloadData: null,
  };
};

const estimationSheetReducer = createReducer(initialState, {
  [Types.SET_FULL_PAGE_LAYOUT]: setFullPageLayout,
  [Types.SET_STEP]: setStep,
  [Types.ADD_FILE]: addFile,
  [Types.ADD_FILE2]: addFile2,
  [Types.REMOVE_FILE]: removeFile,
  [Types.REMOVE_FILE2]: removeFile2,
  [Types.RESET]: reset,
  [Types.SAVE_ESTIMATION_DATA_REQUEST]: saveEstimationDataRequest,
  [Types.SAVE_ESTIMATION_DATA_SUCCESS]: saveEstimationDataSuccess,
  [Types.SAVE_ESTIMATION_DATA_FAILURE]: saveEstimationDataFailure,
  [Types.SET_PARSING_PROGRESS]: setParsingProgress,
  [Types.SET_PARSING_STATE]: setParsingState,
  [Types.SET_GLOBAL_DOWNLOAD_DATA]: setGlobalDownloadData,
  [Types.CLEAR_GLOBAL_DOWNLOAD_DATA]: clearGlobalDownloadData,
});

export default estimationSheetReducer;
